module.exports = __webpack_public_path__ + "static/img/Josh_Kennedy_desktop.3837ea7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Josh_Kennedy_desktop.jpg
// module id = H/zr
// module chunks = 0